export default "<div class=\"container\">\n  <page-header></page-header>\n  <router-outlet></router-outlet>\n</div>"